export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12867.7304ea63.jpg";